import { createAction, props } from '@ngrx/store';
import {
  AlreadyImportedGroup,
  CenterTeacher,
  CheckboxItemNode,
  ErrorModel,
  Group,
  GroupCreationData,
  OnmatItinerary,
  PeriodItinerary,
  SelectedStudent,
  StudentsGroup,
  TeacherGroup,
} from '@tekman/onmat/models';

export const loadGroups = createAction('[Group Selector] Load groups');
export const loadGroupsByAcademicYear = createAction(
  '[Group Selector] Load groups by academic year',
  props<{
    academicYearId: string;
  }>()
);

export const loadGroupsSuccess = createAction('[Groups/API] Load Groups Success', props<{ groups: Group[] }>());
export const loadGroupsFailure = createAction('[Groups/API] Load Groups Failure', props<{ error: ErrorModel }>());

export const selectGroup = createAction(
  '[Groups Effect] Select group to load in group selector',
  props<{
    selectedGroup: Group;
  }>()
);

export const saveGroup = createAction('[Save Group] Save group', props<{ groupCreation: GroupCreationData }>());
export const saveGroupSuccess = createAction(
  '[Save Group] Save group Success',
  props<{
    group?: Group;
    groupId: string;
    successStudents: StudentsGroup[];
    failedStudents: StudentsGroup[];
    failedTeachers: CenterTeacher[];
  }>()
);
export const saveGroupFailure = createAction('[Save Group] Save group Failure', props<{ error: ErrorModel }>());
/** The external class (Classroom / Teams) had already been imported: the API rejects the creation with a 400. */
export const saveGroupAlreadyImported = createAction(
  '[Save Group] Save group already imported',
  props<{ alreadyImportedGroup: AlreadyImportedGroup }>()
);
export const resetSaveGroupAlreadyImported = createAction('[Save Group] Reset save group already imported');

export const removeGroup = createAction('[Remove Group] Remove group', props<{ groupId: string }>());
export const removeGroupSuccess = createAction('[Remove Group] Remove group Success', props<{ groupId: string }>());
export const removeGroupFailure = createAction('[Remove Group] Remove group Failure', props<{ error: ErrorModel }>());

export const selectedGroupSuccess = createAction(
  '[Groups Effect] Select group Success',
  props<{
    selectedGroup: Group;
  }>()
);

export const modifyPeriodItineraries = createAction(
  '[Groups Effect] Modify Period Itineraries',
  props<{
    periodItineraries: PeriodItinerary;
    selectedGroupId: string;
  }>()
);

export const rollbackPeriodItineraries = createAction(
  '[Groups Effect] Rollback Period Itineraries',
  props<{ periodItinerariesId: string; selectedGroupId: string }>()
);
export const rollbackPeriodItinerariesSuccess = createAction(
  '[Groups Effect] Rollback Period Itineraries Success',
  props<{ periodItinerariesId: string; selectedGroupId: string }>()
);
export const rollbackPeriodItinerariesFailure = createAction(
  '[Groups Effect] Rollback Period Itineraries Failure',
  props<{ error: ErrorModel }>()
);

export const selectStudent = createAction(
  '[Groups/ evaluate] Select student Evaluation',
  props<{
    selectedStudent: SelectedStudent;
  }>()
);

export const selectedStudentSuccess = createAction(
  '[Evaluate Effect] Select teams Success',
  props<{
    teams: CheckboxItemNode[];
  }>()
);

export const selectedStudentFailure = createAction(
  '[StudentsGroup/API] Selected Students Group Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const loadTeachers = createAction(
  '[Groups/teachers] Load Teachers',
  props<{
    academicYearId: string;
  }>()
);

export const loadTeachersSuccess = createAction(
  '[Groups/teachers] Load teachers Success',
  props<{
    teachers: CenterTeacher[];
  }>()
);

export const loadTeachersFailure = createAction(
  '[Groups/teachers] Load teachers Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const deleteTeacher = createAction(
  '[Groups/teachers] Delete teachers Success',
  props<{
    teacherId: string;
  }>()
);
export const deleteTeacherSuccess = createAction('[Groups/teachers] Delete teachers Success');
export const deleteTeacherFailure = createAction(
  '[Groups/teachers] Delete teachers Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const loadStudentsGroupSuccess = createAction(
  '[StudentsGroup/API] Load Students Group Success',
  props<{ groupId: string; students: StudentsGroup[] }>()
);

export const loadStudentsGroupFailure = createAction(
  '[StudentsGroup/API] Load Students Group Failure',
  props<{
    error: ErrorModel;
  }>()
);
export const hotjarSuccess = createAction('[Hotjar] Load hotjar Success');

export const hotjarFailure = createAction('[Hotjar] Load hotjar Failure', props<{ error: ErrorModel }>());

export const loadTeamsSuccess = createAction(
  '[Teams/API] Load Teams Success',
  props<{ teams: CheckboxItemNode[]; students: StudentsGroup[]; groupId: string }>()
);

export const updatedTeamsSuccess = createAction(
  '[Teams] Updated Teams Success',
  props<{
    teams: CheckboxItemNode[];
  }>()
);

export const loadTeamsFailure = createAction('[Teams/API] Load Teams Failure', props<{ error: ErrorModel }>());

export const removeGroups = createAction('[Groups] Remove groups');
export const removeFailedStudentsImported = createAction('[Groups] Remove students imported that failed');

export const loadItinerarySuccess = createAction(
  '[Itinerary/API] Get Itinerary Onmat Success',
  props<{ groupId: string; itinerary: OnmatItinerary }>()
);
export const loadItineraryFailure = createAction(
  '[Itinerary/API] Get Itinerary Onmat Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const loadProgressSuccess = createAction(
  '[Groups/API] Load User Progress Success',
  props<{
    progress: string;
  }>()
);
export const loadProgressFailure = createAction(
  '[Progress/API] Load User Progress Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const updateProgress = createAction(
  '[Groups/API] Update User Progress',
  props<{
    stepId: string;
    groupId: string;
  }>()
);

export const saveTeachers = createAction('[Groups/API] Save Teachers', props<{ teachers: TeacherGroup[] }>());
export const saveTeachersFailure = createAction('[Groups/API] Save Teachers Failure', props<{ error: ErrorModel }>());
export const saveTeachersSuccess = createAction(
  '[Groups/API] Save Teachers Success',
  props<{
    failedTeachers: CenterTeacher[];
  }>()
);

export const updatePassword = createAction(
  '[Users/API] Update Password',
  props<{
    studentId: string;
    password: string;
  }>()
);
export const updatePasswordSuccess = createAction('[Users/API] Update Password Success');
export const updatePasswordFailure = createAction(
  '[Users/API] Update Password Failure',
  props<{
    error: ErrorModel;
  }>()
);
export const updateStudentInfo = createAction(
  '[Users/API] Update Info',
  props<{
    studentId: string;
    name: string;
    lastName: string;
  }>()
);
export const updateStudentInfoSuccess = createAction('[Users/API] Update Info Success');
export const updateStudentInfoFailure = createAction('[Users/API] Update Info Failure', props<{ error: ErrorModel }>());
export const deleteStudent = createAction(
  '[Users/API] Delete Student',
  props<{
    groupId: string;
    studentId: string;
  }>()
);
export const deleteStudentSuccess = createAction('[Users/API] Delete Student Success', props<{ id: string }>());
export const deleteStudentFailure = createAction('[Users/API] Delete Student Failure', props<{ error: ErrorModel }>());
export const inviteStudents = createAction(
  '[Users/API] Invite Student',
  props<{
    groupId: string;
    userNames: string[];
  }>()
);
export const inviteStudentSuccess = createAction(
  '[Users/API] Invite Student Success',
  props<{
    students: StudentsGroup[];
    failedStudents: StudentsGroup[];
  }>()
);
export const inviteStudentFailure = createAction('[Users/API] Invite Student Failure', props<{ error: ErrorModel }>());

export const loadEditableTeachers = createAction('[Groups/teachers] Load Editable Teachers');
export const loadEditableTeachersSuccess = createAction(
  '[Groups/teachers] Load Editable Teachers Success',
  props<{ teachers: TeacherGroup[] }>()
);
export const loadEditableTeachersFailure = createAction(
  '[Groups/teachers] Load Editable Teachers Failure',
  props<{
    error: ErrorModel;
  }>()
);
export const addStepToItinerary = createAction(
  '[Steps/API] Add Steps To Itinerary',
  props<{ itineraryId: string; groupId: string; stepId: string }>()
);
export const addStepToItinerarySuccess = createAction('[Steps/API] Add Steps To Itinerary Success');
export const addStepToItineraryFailure = createAction(
  '[Steps/API]  Add Steps To Itinerary Failure',
  props<{
    error: ErrorModel;
  }>()
);
export const deleteStepInItinerary = createAction(
  '[Steps/API]  Add Steps To Itinerary',
  props<{ itineraryId: string; groupId: string; stepId: string }>()
);
export const deleteStepInItinerarySuccess = createAction('[Steps/API] Update Steps in Itinerary Success');
export const deleteStepInItineraryFailure = createAction(
  '[Steps/API] Update Steps in Itinerary Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const loadEditableGroup = createAction('[Groups/API] Get Editable Group', props<{ id: string }>());
export const loadEditableGroupSuccess = createAction(
  '[Groups/API] Get Editable Group Success',
  props<{
    group: Group;
  }>()
);
export const loadEditableGroupFailure = createAction(
  '[Groups/API] Get Editable Group Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const updateStepCompleted = createAction(
  '[Steps/API] Update Step Completed',
  props<{ stepId: string; groupId: string; isCompleted: boolean }>()
);
export const updateStepCompletedSuccess = createAction(
  '[Groups/API] Update Step Completed Success',
  props<{
    stepId: string;
    isCompleted: boolean;
  }>()
);
export const updateStepCompletedFailure = createAction(
  '[Groups/API] Update Step Completed Failure',
  props<{
    error: ErrorModel;
  }>()
);

export const resetAlerts = createAction('[Group] Reset students and teachers errors and success');
